import { Category } from '@bookstore/shared';
import { Link } from 'react-router-dom';

interface SubCategoryBadgeProps {
  subCategory: Category;
}

const SubCategoryBadge = ({ subCategory }: SubCategoryBadgeProps) => {
  return (
    <Link
      to={`/products/${subCategory.seoUrl}`}
      onClick={(e) => e.stopPropagation()}
      className="group/badge relative inline-flex items-center gap-1.5 text-xs font-medium bg-gradient-to-r from-gray-100 to-gray-50 hover:from-primary-50 hover:to-primary-100 text-gray-700 hover:text-primary-700 px-3 py-1.5 rounded-lg border border-gray-200 hover:border-primary-300 transition-all duration-200 hover:shadow-sm hover:-translate-y-0.5"
    >
      <div className="w-1.5 h-1.5 rounded-full bg-gray-400 group-hover/badge:bg-primary-500 transition-colors" />
      {subCategory.name}
    </Link>
  );
};

export default SubCategoryBadge;
